declare var WURFL: any;
import { JwtHelperService } from '@auth0/angular-jwt';
import { Auth } from '../model/auth';
import { Buffer } from "buffer/index"

export class Helper {

  public static baseApiUrl = 'https://api.facinatus.net/';
  //public static baseApiUrl = 'http://localhost:80/';

  //static baseApiUpload = "https://up.assets.simplifica.top/content/";
  static baseUpload = "facinatus";
  //public static basePathContent = "https://assets.simplifica.top/" + Helper.baseUpload + "/";
  public static basePathContent = "https://cdn.simplifica.top/" + Helper.baseUpload + "/";

  public static showSlider: boolean;

  public static RefreshSlider() {
    setTimeout(() => {
      Helper.showSlider = true;
      setTimeout(() => {
        Helper.showSlider = false;
        setTimeout(() => {
          Helper.showSlider = true;
        }, 500);
      }, 50);
    }, 500);
  }

  static isValidMailFormat(mail: string): boolean {
    let EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    if (mail != "" && (mail.length <= 5 || !EMAIL_REGEXP.test(mail))) {
      return false;
    }

    return true;
  }
  static PrimeiraMinuscula(texto: string) {
    var qtd = texto.length;
    var prim = texto.substring(0, 1);
    var resto = texto.substring(1, qtd);
    return prim.toLocaleLowerCase() + resto;
  }

  private static getAuth(): Auth {
    var auth = localStorage.getItem("jwt");
    if (auth) {
      var obj = JSON.parse(auth);
      var rt = new Auth();
      rt.Assing(obj);
      return rt;
    }
    else {
      return null;
    }
  }

  static isTokenExpired(): boolean {

    var auth = Helper.getAuth();
    if (auth) {
      var jwtHelper = new JwtHelperService();
      return jwtHelper.isTokenExpired(auth.token);
    }
    else {
      return true;
    }
  }
  static decodeToken(): any {
    var auth = Helper.getAuth();
    if (auth) {
      var jwtHelper = new JwtHelperService();
      return jwtHelper.decodeToken(auth.token);
    }
    else {
      return null;
    }
  }

  static getPapelToken(): any {
    var auth = Helper.getAuth();
    if (auth && auth.papel) {

      return auth.papel;
    }
    else {
      return ";"
    }
  }
  static getNomeToken(): any {
    var auth = Helper.getAuth();
    if (auth && auth.nome) {

      return auth.nome;
    }
    else {
      return "";
    }
  }
  static getVisualizaPromocao(): any {
    var auth = Helper.getAuth();
    if (auth && auth.promo) {
      return auth.promo;
    }
    else {
      return "";
    }
  }
  static getCodTab(): any {
    var auth = Helper.getAuth();
    if (auth && auth.codTab) {

      return auth.codTab;
    }
    else {
      return "";
    }
  }

  static getIsDistribuidor(): boolean {
    var auth = Helper.getAuth();
    return !!(auth && auth.isDistribuidor);
  }


  static getVendedorToken(): any {
    var auth = Helper.getAuth();
    if (auth && auth.vendedorId) {

      return auth.vendedorId;
    }
    else {
      return "";
    }
  }

  static getUserIdToken(): any {
    var auth = Helper.getAuth();
    if (auth) {
      var jwtHelper = new JwtHelperService();
      var tk = jwtHelper.decodeToken(auth.token);
      return tk.id;
    }
    else {
      return ";"
    }
  }

  static pad(num: number, size: number): string {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }



  static NavToDashboard(router, guiaAtiva: string = '') {
    var papelUsuario = this.getPapelToken();
    switch (papelUsuario) {
      case "Usuario":
        router.navigate(['/']);
        break;
      case "Gerente":
      case "Vendedor":
        router.navigate(['/admin']);
        break;
      case "Marketing":
        if (guiaAtiva) {
          router.navigate(['/marketing', guiaAtiva]);
        } else {
          router.navigate(['/marketing']);
        }
        break;
    }
  }


}
